import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import WhyChoose from '../components/sections/WhyChoose';
import SectionDivider from '../components/common/SectionDivider';

const WhyANRPage = () => {
  const theme = useTheme();

  return (
    <Box component="main" sx={{ pt: 10 }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h2" sx={{ 
          mb: 2, 
          fontWeight: 800, 
          textAlign: 'center',
          color: 'warning.main'
        }}>
          Why Choose ANR Mechanical
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 3, 
          textAlign: 'center',
          color: 'text.secondary',
          maxWidth: 800,
          mx: 'auto'
        }}>
          Discover what sets us apart as the NY metro area's trusted mechanical contractor with over 25 years of excellence.
        </Typography>
      </Container>
      
      <SectionDivider variant="wave" color="warning.main" mt={1} mb={2} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(255,160,0,0.06))` }}>
        <WhyChoose />
      </Box>
      
      <SectionDivider variant="line" color="warning.main" mt={6} mb={6} />
      
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          size="large"
          href="tel:(516) 414-0165"
          sx={{ 
            px: 4, 
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Experience the ANR Difference
        </Button>
      </Container>
    </Box>
  );
};

export default WhyANRPage;
